class WishlistButton extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const buttons = this.querySelectorAll("button");
        buttons.forEach((button) => {
            button?.addEventListener("click", this.onButtonClick.bind(this));
        })
    }

    onButtonClick(e: Event) {
        // Swym Default Function
        e.preventDefault();
        const target = e.currentTarget as HTMLElement;

        if(target.classList.contains("swym-added")) {
            var epi = +e.currentTarget.getAttribute("data-variant-id");
            var empi = +e.currentTarget.getAttribute("data-product-id");
            window._swat.fetch(function(products:any) {
                products.forEach(function(product:any) {
                    if (epi && empi && product.epi == epi && product.empi == empi){
                        window._swat.removeFromWishList(product, function() {
                            if (!window.SwymCallbacks) {
                                window.SwymCallbacks = [];
                            }
                            window.SwymCallbacks.push(swymRenderWishlist);
                        });
                    }
                });
            })
        }
    }
}

customElements.define("wishlist-button", WishlistButton);

